import React from 'react';
import { styled } from '@mui/material/styles';

/**
 * SkipNavLink — Enterprise Design System
 *
 * Renders a visually-hidden "Skip to main content" link as the first focusable
 * element on the page. Becomes visible on focus for keyboard users.
 *
 * Requirements: 17.6
 */

const StyledLink = styled('a')(({ theme }) => ({
  position: 'absolute',
  top: '-100%',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: theme.zIndex?.tooltip + 1 || 1600,
  padding: '8px 16px',
  backgroundColor: theme.palette?.primary?.main || '#1a56db',
  color: '#fff',
  fontWeight: 600,
  fontSize: '0.875rem',
  borderRadius: '0 0 8px 8px',
  textDecoration: 'none',
  outline: 'none',
  transition: 'top 0.2s ease',
  '&:focus': {
    top: 0,
    outline: `2px solid ${theme.palette?.primary?.dark || '#1e40af'}`,
    outlineOffset: '2px',
  },
}));

export default function SkipNavLink({ targetId = 'main-content', label = 'Skip to main content' }) {
  return (
    <StyledLink href={`#${targetId}`}>
      {label}
    </StyledLink>
  );
}
